export const language: any = {
  title: "Hey! Cooker 社区",
  follow: "关注",
  follower: "粉丝",
  post_share: "分享的帖子",
  like_share: "喜欢",
  report: "举报违规",
  delete_post: "删除帖子",
  delete_comment: "删除评论",
  confirm_report: "您确定这个帖子包含违反社区准则的内容吗？成功举报后，您将不再看到这个帖子。",
  confirm_report_comment: "您确定这个评论违反社区准则吗？",
  toats_report: "感谢您举报违规，您的举报正在审核中。",
  confirm_delete: "您想删除这个帖子吗？",
  confirm_delete_comment: "您确定要删除这个评论吗？",
  toast_delete: "删除成功",
  text_yes: "是",
  text_no: "否",
  create: {
    title: "创建帖子 - Hey!Cooker 社区",
    content_placeholder: "请输入您的帖子内容",
    submit: "立即分享",
    add_image_by_camera: "使用相机拍照",
    add_image_by_gallery: "选择图片",
    add_video_by_camera: "录制视频",
    add_video_by_gallery: "选择视频",
  },
  detail: {
    shared: "已分享",
    shared_community: "已与社区分享照片（视频）"
  },
  follwed: "已关注",
  comment: {
    placeholder: "请输入评论",
    submit: "提交",
    nodata: "在这里留下评论，成为第一个评论的人！",
    load_more: "查看更多评论",
    not_login: "请登录后再评论",
    delete: "删除评论",
    delete_confirm: "您确定要删除此评论吗？",
    delete_success: "评论删除成功",
    report: "举报",
    report_confirm: "您确定此评论违反了社区准则吗？",
    report_success: "感谢您的举报，\n您的举报正在审核中",
  },
  bottom_navigation: "社区",
  shared_post: "已分享帖子"
}


